const DISMISSAL_KEY_PREFIX = "zrs-cms:banner-dismissed:";
const DEFAULT_CLOSE_LABEL = "Close banner";
const DEFAULT_BANNER_LABEL = "Banner";
const BANNER_MOUNT_ID = "cms-banner-mount";
const BANNER_SSR_ATTR = "data-banner-ssr";
export {
  BANNER_MOUNT_ID,
  BANNER_SSR_ATTR,
  DEFAULT_BANNER_LABEL,
  DEFAULT_CLOSE_LABEL,
  DISMISSAL_KEY_PREFIX
};
